import { render, staticRenderFns } from "./aggregatorModel.vue?vue&type=template&id=1ca251f4&"
import script from "./aggregatorModel.vue?vue&type=script&lang=ts&"
export * from "./aggregatorModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports